var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClean({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.664 14.116C19.216 11.668 19 7.192 19 6.4H17.2V8.8H12.4V6.4H10C10 5.08 11.08 4 12.4 4H20.8V5.2C20.8 5.296 20.848 10.756 22.936 12.844L21.664 14.116ZM22 4V6.4H23.2V4H22ZM19.6 16C17.2 13.6 17.2 10 17.2 10H12.4V12.4C12.4 13.6 12.4 13.6 11.2 14.8C10 16 10 17.2 10 17.2V25.6C10 26.92 11.08 28 12.4 28H17.2C18.52 28 19.6 26.92 19.6 25.6V16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClean);
export default __webpack_public_path__ + "static/media/clean.aa9a45932da671f8607983eacbb83e43.svg";
export { ForwardRef as ReactComponent };